import { useState } from 'react';
import './carrier-logo.css';

export interface CarrierLogoProps {
  /** The carrier's `logoUrl` (self-hosted by the API, Q89); null or undefined draws nothing. */
  src: string | null | undefined;
  className?: string;
}

/**
 * The small square airline mark in front of the carrier's name (S3 rows, the S5 board). The
 * name is always shown beside it, so the mark is decorative (empty alt), and a missing or
 * broken logo leaves exactly the name, as before logos existed.
 */
export function CarrierLogo({ src, className }: CarrierLogoProps) {
  const [failed, setFailed] = useState<string | null>(null);
  if (!src || failed === src) return null;
  return (
    <img
      className={['carrier-logo', className].filter(Boolean).join(' ')}
      src={src}
      alt=""
      width={18}
      height={18}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(src)}
    />
  );
}
